const csrfToken = () => {
  const tokenTag = document.head.querySelector('[name="csrf-token"]')
  if (tokenTag) return tokenTag.content
  return null
}

export default csrfToken
